import { useEffect } from "react";
import PropTypes from "prop-types";
import { Line } from "@vds/lines";
import { TextWrapper, TextWrapperSpan } from "../../../constants/common/StyledGlobalConstants";

function ConfirmedAppointmentDetails({ apptDateAndTime, confirmationRef }) {
  const { slot, slotDate } = apptDateAndTime;

  useEffect(() => {
    confirmationRef?.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [apptDateAndTime]);

  return (
    <>
      <Line type="secondary" surface="light" style={{ marginTop: "2rem" }} />
      <TextWrapper fontWeight="700" fontSize="1.25rem" lineHeight="1.5rem" marginTop="2rem !important">
        Confirmed appointment time
      </TextWrapper>
      <TextWrapper fontWeight="400" fontSize="0.875rem" marginTop="1rem !important">
        <b>Date:</b> <TextWrapperSpan marginLeft="0.5rem">{slotDate}</TextWrapperSpan>
      </TextWrapper>
      <TextWrapper fontWeight="400" fontSize="0.875rem" marginTop="0.5rem !important" ref={confirmationRef}>
        <b>Time slot:</b>
        <TextWrapperSpan marginLeft="0.5rem">{slot}</TextWrapperSpan>
      </TextWrapper>
    </>
  );
}

ConfirmedAppointmentDetails.propTypes = {
  apptDateAndTime: PropTypes.shape({
    slot: PropTypes.string,
    slotDate: PropTypes.string,
  }).isRequired,
  confirmationRef: PropTypes.object,
};

export default ConfirmedAppointmentDetails;
